<template>
  <v-container grid-list-lg fluid>
    <v-alert
      v-if="selectedCustomer"
      border="left"
      type="error"
      transition="slide-y-transition"
      dismissible
      class="mb-1"
      v-model="selectedCustomer.alert"
      color="red"
    >
      <strong>{{ selectedCustomer.note }}</strong>
    </v-alert>
    <v-layout column>
      <v-flex>
        <v-card outlined>
          <v-toolbar dense flat color="grey lighten-3">
            <v-toolbar-title> Create Order </v-toolbar-title>
            <v-spacer> </v-spacer>
            <v-btn
              color="info"
              small
              :disabled="Order.OrderDetails.length === 0"
              @click="saveOrder"
              >{{ invoiceTotal | currency }} Save</v-btn
            >
            <v-btn small text @click.stop.prevent="cancel">Cancel</v-btn>
          </v-toolbar>
          <v-card-text>
            <v-row class="pl-2" justify="space-between">
              <v-col cols="12" sm="12" md="4">
                <AutoComplete
                  :initValue="initDonor"
                  v-model="selectedCustomer"
                  :errorMessages="selectCustomerError"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <SalesMan v-model="selectedUser" :initValue="initUser" />
              </v-col>
              <v-col sm="6" md="2">
                <DateSelector label="Date" v-model="Order.date" />
              </v-col>
              <v-col sm="6" md="2">
                <v-dialog v-model="orderNote" width="500">
                  <template v-slot:activator="{ on }">
                    <v-btn outlined v-on="on">Order Note</v-btn>
                  </template>

                  <v-card>
                    <ModelTitle
                      title="Order Note"
                      @close="orderNote = !orderNote"
                    />

                    <v-card-text class="mt-3">
                      <v-textarea
                        outlined
                        dense
                        hide-details
                        v-model="Order.note"
                        label="Order Note"
                      ></v-textarea>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="orderNote = false"
                        >Close</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex>
        <ProductSearchBar @submit="addRow" />
      </v-flex>
      <v-flex v-if="$vuetify.breakpoint.xsOnly">
        <div class="text-center">
          <v-dialog v-model="showCart" fullscreen flat class="elevation-0">
            <template v-slot:activator="{ on }">
              <v-card color="info" dark hover v-on="on">
                <v-card-text>
                  <div class="text-center font-weight-bold">
                    {{ Order.OrderDetails.length }} rows in cart
                  </div>
                  <div class="text-center">Click here to view cart</div>
                </v-card-text>
              </v-card>
            </template>

            <v-card flat>
              <v-toolbar dark color="#F0C316">
                <v-btn icon small dark @click="showCart = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Cart</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                    text
                    :disabled="Order.OrderDetails.length === 0"
                    @click="saveOrder"
                    >{{ invoiceTotal | currency }} Save</v-btn
                  >
                </v-toolbar-items>
              </v-toolbar>

              <v-card outlined tile>
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      v-for="(item, index) in Order.OrderDetails"
                      :key="index"
                    >
                      <v-card outlined>
                        <v-card-text>
                          <div>
                            <v-btn icon @click="deleteItem(index)">
                              <v-icon color="red">delete</v-icon>
                            </v-btn>
                            {{ item.name }}
                          </div>
                          <div><span>Qty: </span>{{ item.qty }}</div>
                          <v-row>
                            <v-col
                              ><span>Price: </span
                              >{{ item.price | currency }}</v-col
                            >
                            <v-col
                              ><span>Total: </span
                              >{{ (item.qty * item.price) | currency }}</v-col
                            >
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-divider></v-divider>
            </v-card>
          </v-dialog>
        </div>
      </v-flex>
      <v-flex v-if="!$vuetify.breakpoint.xsOnly">
        <v-card outlined>
          <v-card-text>
            <v-data-table
              :headers="headers"
              hide-default-footer
              :itemsPerPage="1000"
              id="invoice-cart"
              no-data-text="No item on this order yet"
              :items="Order.OrderDetails"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>
                    <v-layout align-center justify-start row fill-height wrap>
                      <v-btn icon @click="deleteItem(index)">
                        <v-icon color="red">delete</v-icon>
                      </v-btn>
                      <v-text-field
                        v-model="item.name"
                        outlined
                        hide-details
                        @focus="$event.target.select()"
                        dense
                      ></v-text-field>
                    </v-layout>
                  </td>
                  <td class="text-center">
                    <v-text-field
                      v-model="item.qty"
                      :disabled="item.imeiNumber ? true : false"
                      outlined
                      class="centered-input"
                      hide-details
                      dense
                      @focus="$event.target.select()"
                    ></v-text-field>
                  </td>
                  <td class="text-right">
                    <v-text-field
                      v-model="item.price"
                      outlined
                      class="al-r"
                      hide-details
                      @focus="$event.target.select()"
                      dense
                    ></v-text-field>
                  </td>
                  <td class="text-right">
                    {{ (item.qty * item.price) | currency }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card v-if="totalQty > 0" outlined tile>
            <v-card-text>
              <div class="text-left">
                <span class="font-weight-medium">{{ totalQty }}</span> Total
                Item
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const { validationMixin } = require("vuelidate");
const { required, minValue } = require("vuelidate/lib/validators");
import DateSelector from "@/components/DateSelector";
import AutoComplete from "@/modules/Customer/components/AutoComplete";
import SalesMan from "@/modules/User/components/AutoComplete.vue";
import ProductSearchBar from "@/modules/Order/InHouse/components/ProductSearchBar";
import orderService from "../service";
import { mapGetters } from "vuex";

export default {
  name: "create-order",
  data() {
    return {
      initDonor: null,
      initUser: null,
      selectedUser: null,
      showCart: false,
      orderNote: false,
      selectedCustomer: null,
      Customer: [],
      loading: true,
      Order: {
        date: this.$moment().toISOString(),
        note: null,
        CustomerId: null,
        OrderDetails: [],
      },
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Quantity",
          align: "center",
          value: "qty",
          width: "100",
          sortable: false,
        },
        {
          text: "Price",
          align: "right",
          value: "price",
          sortable: false,
        },
        {
          text: "Total",
          align: "right",
          value: "total",
          sortable: false,
        },
      ],
    };
  },
  components: {
    DateSelector,
    AutoComplete,
    SalesMan,
    ProductSearchBar,
  },
  mixins: [validationMixin],
  validations: {
    Order: {
      CustomerId: {
        required,
        minValue: minValue(1),
      },
    },
  },
  async created() {
    if (this.$route.query && this.$route.query.CustomerId) {
      this.initDonor = this.$route.query.CustomerId;
      // const customer = await customerService.getById(this.$route.query.CustomerId)
      // console.log('djlfkdjf', customer)
      // this.initDonor = customer.data
    }
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    totalQty() {
      let total = 0;
      if (this.Order.OrderDetails) {
        this.Order.OrderDetails.map((row) => {
          total += parseFloat(row.qty);
        });
      }

      return total;
    },
    selectCustomerError() {
      const errors = [];
      if (!this.$v.Order.CustomerId.$dirty) return errors;
      if (!this.$v.Order.CustomerId.required)
        errors.push("Pleaes select customer");
      if (!this.$v.Order.CustomerId.minValue)
        errors.push("Pleaes select customer");
      return errors;
    },
    invoiceTotal() {
      let total = 0;
      this.Order.OrderDetails.map((row) => {
        total += row.total;
      });
      return total;
    },
  },
  watch: {
    selectedCustomer(val) {
      this.Order.CustomerId = this.selectedCustomer.id;
      if (val) {
        if (val.SalesRep) {
          this.initUser = val.SalesRep;
        } else {
          this.initUser = this.currentUser;
        }
      } else {
        this.initUser = this.currentUser;
      }
    },
  },
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    saveOrder() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        if (this.Order.OrderDetails.length > 0) {
          this.Order.SalesRepUserId = this.selectedUser.id;
          return orderService.create(this.Order).then((result) => {
            console.log("result", result);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Order was created!",
              });

            this.$router.go(-1);
          });
        }
      }
    },
    deleteItem(i) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.Order.OrderDetails.splice(i, 1);
        }
      });
    },

    addRow(val) {
      this.Order.OrderDetails.push({
        ProductId: val.id,
        name: val.Bar.name,
        price: val.Bar.price,
        total: val.Bar.price * val.Bar.qty,
        qty: val.Bar.qty,
      });
    },
  },
};
</script>

<style scoped>
#invoice-cart {
  height: calc(100vh - 528px);
  overflow: auto;
}
</style>
